import {connect} from 'react-redux'
import Leaderboard from '../components/leaderboard/Leaderboard'
import {RootState} from '../../common/redux/store'

const mapStateToProps = (state: RootState) => ({
  leaderboardEntries: state.dashboard.leaderboardEntries,
})

export default connect(mapStateToProps)(Leaderboard)
